import React, { useState } from 'react';
import { COLORS } from '../theme';
import { getUserRank } from '../utils';

const TeamSection = ({ appConfig, teamMembers }) => {
    const [displayLimit, setDisplayLimit] = useState(20);
    
    const hasSns = appConfig.snsLinks && (
        appConfig.snsLinks.web || appConfig.snsLinks.x || appConfig.snsLinks.instagram || 
        appConfig.snsLinks.tiktok || appConfig.snsLinks.youtube || 
        appConfig.snsLinks.facebook || appConfig.snsLinks.threads || appConfig.snsLinks.custom
    );

    return (
      <div style={{paddingBottom:'20px'}}>
          <div className="team-hero">
              {appConfig.teamPhotoUrl ? 
                  <img src={appConfig.teamPhotoUrl} className="team-cover-img" alt="Team" /> :
                  <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'30px', color:'#999'}}>No Photo</div>
              }
              <div className="team-emblem-container">
                  {appConfig.teamEmblemUrl ? 
                      <img src={appConfig.teamEmblemUrl} className="team-emblem-img" alt="Emblem" /> :
                      <div style={{width:'100%', height:'100%', borderRadius:'50%', background:'#eee', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'30px'}}>⚽</div>
                  }
              </div>
          </div>

          <div className="team-info-section">
              <h2 style={{margin:'0 0 5px 0', fontSize:'24px'}}>{appConfig.appTitle}</h2>
              <div style={{fontSize:'12px', color:'#666', fontWeight:'bold', display:'flex', alignItems:'center', justifyContent:'center', gap:'10px'}}>
                  {appConfig.leagueName && <span>🏆 {appConfig.leagueName}</span>}
                  {appConfig.establishedDate && <span>📅 Est.{appConfig.establishedDate}</span>}
              </div>
              {appConfig.homeGround && <div style={{fontSize:'12px', color:'#999', marginTop:'5px'}}>📍 {appConfig.homeGround}</div>}
              
              {appConfig.teamIntro && (
                  <div style={{marginTop:'20px', fontSize:'14px', lineHeight:'1.6', whiteSpace:'pre-wrap', textAlign:'left'}}>
                      {appConfig.teamIntro}
                  </div>
              )}

              {hasSns && (
                  <div className="sns-grid">
                      {appConfig.snsLinks.web && <a href={appConfig.snsLinks.web} target="_blank" rel="noopener noreferrer" className="sns-btn sns-web">🌐</a>}
                      {appConfig.snsLinks.x && <a href={appConfig.snsLinks.x} target="_blank" rel="noopener noreferrer" className="sns-btn sns-x">𝕏</a>}
                      {appConfig.snsLinks.instagram && <a href={appConfig.snsLinks.instagram} target="_blank" rel="noopener noreferrer" className="sns-btn sns-insta">📷</a>}
                      {appConfig.snsLinks.tiktok && <a href={appConfig.snsLinks.tiktok} target="_blank" rel="noopener noreferrer" className="sns-btn sns-tiktok">🎵</a>}
                      {appConfig.snsLinks.youtube && <a href={appConfig.snsLinks.youtube} target="_blank" rel="noopener noreferrer" className="sns-btn sns-youtube">📺</a>}
                      {appConfig.snsLinks.facebook && <a href={appConfig.snsLinks.facebook} target="_blank" rel="noopener noreferrer" className="sns-btn sns-fb">f</a>}
                      {appConfig.snsLinks.threads && <a href={appConfig.snsLinks.threads} target="_blank" rel="noopener noreferrer" className="sns-btn sns-threads">@</a>}
                      {appConfig.snsLinks.custom && <a href={appConfig.snsLinks.custom} target="_blank" rel="noopener noreferrer" className="sns-btn sns-other">🔗</a>}
                  </div>
              )}
              
              {appConfig.operatingCompany && (
                  <div style={{fontSize:'10px', color:'#ccc', marginTop:'10px'}}>
                      運営: {appConfig.operatingCompany}
                  </div>
              )}
          </div>

          {appConfig.showMemberList && (
              <div className="card" style={{margin:'0 20px'}}>
                  <h3 style={{fontSize:'16px', borderBottom:'1px solid #eee', paddingBottom:'10px', marginBottom:'15px'}}>👥 メンバー一覧</h3>
                  <div className="member-grid">
                      {teamMembers.length > 0 ? teamMembers.slice(0, displayLimit).map((m, i) => (
                          <div key={i} className="member-item">
                              {m.pictureUrl ? <img src={m.pictureUrl} className="member-avatar" alt="" /> : <div className="member-avatar" style={{display:'flex', alignItems:'center', justifyContent:'center'}}>👤</div>}
                              <div style={{fontSize:'10px', fontWeight:'bold', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', width:'100%'}}>{m.displayName}</div>
                              <div style={{fontSize:'9px', color:'#999'}}>#{m.number || '-'}</div>
                              {m.rankIcon && <div style={{position:'absolute', top:'-5px', right:'-5px', fontSize:'12px'}}>{m.rankIcon}</div>}
                          </div>
                      )) : (
                          <div style={{gridColumn:'1 / -1', textAlign:'center', color:'#999', fontSize:'12px'}}>メンバーがいません</div>
                      )}
                  </div>
                  {teamMembers.length > displayLimit && (
                      <div style={{textAlign:'center', marginTop:'10px'}}>
                          <button onClick={()=>setDisplayLimit(prev=>prev+20)} className="btn btn-sm" style={{background:'#eee', color:'#666'}}>もっと見る</button>
                      </div>
                  )}
              </div>
          )}
      </div>
    );
};

export default TeamSection;